module.exports = __webpack_public_path__ + "img/camera-reverse.e8854f3b.svg";